

export const formatLocalDateToISO = (date) => {
    const pad = (n) => (n < 10 ? '0' + n : n);

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // getMonth() retorna 0-11
    const day = pad(date.getDate());

    return `${year}-${month}-${day}`;
}
